import { render, staticRenderFns } from "./DependencyTargetCard.vue?vue&type=template&id=783d1432"
import script from "./DependencyTargetCard.vue?vue&type=script&lang=ts"
export * from "./DependencyTargetCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,UITooltip: require('/build/apps/legacy/components/Common/UI2/Tooltip/UITooltip.vue').default,ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default})
